import { StrictMode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';

import '@/styles/global.css';

import App from './App.tsx';
import { queryClient } from './lib/query-client.ts';
import { Toaster } from './components/ui/sonner.tsx';
import { TooltipProvider } from './components/ui/tooltip';
import { env } from './config/env.ts';

createRoot(document.getElementById('root')!).render(
  <GoogleOAuthProvider clientId={env.googleClientID}>
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={200}>
          <Toaster
            className="custom-sonner-toast"
            position="top-right"
            richColors
            closeButton={true}
          />
          <App />
        </TooltipProvider>
      </QueryClientProvider>
    </StrictMode>
  </GoogleOAuthProvider>,
);
